module.exports = __webpack_public_path__ + "img/roofcal.f9af2153.svg";